import { useState, useEffect } from "react";
import ApiCall from "../auth/ApiCall";

interface RuleResponse {
  rule?: {
    name?: string;
    teams?: string[];
    houses?: string[];
    rule_details?: Record<string, unknown>;
    notifications?: Record<string, unknown>;
    sport?: number;
    sport_name?: string;
    type?: number;
  };
  error?: string;
}

interface GetRuleReturn {
  ruleData: RuleResponse | null;
  isRuleLoading: boolean;
  ruleError: string | null;
}

export function useRule(ruleId: string | null): GetRuleReturn {
  const [ruleData, setRuleData] = useState<RuleResponse | null>(null);
  const [isRuleLoading, setIsRuleLoading] = useState(true);
  const [ruleError, setRuleError] = useState<string | null>(null);

  useEffect(() => {
    if (!ruleId) {
      setIsRuleLoading(false);
      return;
    }

    const fetchRule = async () => {
      try {
        const response = await ApiCall.makeAuthenticatedRequest(
          "/api/load_rule/" + ruleId,
        );

        if ("error" in response) {
          setRuleError(response.error as string);
        } else {
          setRuleData(response as RuleResponse);
        }
      } catch (err: unknown) {
        setRuleError(
          err instanceof Error ? err.message : "Failed to fetch rule",
        );
      } finally {
        setIsRuleLoading(false);
      }
    };

    fetchRule();
  }, [ruleId]);

  return { ruleData, isRuleLoading, ruleError };
}
